// extracted by mini-css-extract-plugin
export default {"ad_wrapper":"AdBlock_ad_wrapper__3vBye","ad_text":"AdBlock_ad_text__vjT5Q","ad_link":"AdBlock_ad_link__tBL6O"};